import { createFileRoute, Link } from '@tanstack/react-router';
import { useQuery } from '@tanstack/react-query';
import { getInstallationId, learnerApiJson } from '@/lib/learner-api';
import { useLearnerAuth } from '@/providers/LearnerAuth';
import { typeScale } from '@/lib/typography';

type Catalog = { puzzle_date: string }[];
type Board = { entries: Array<{ rank: number; nickname: string; duration_seconds: number; is_you: boolean }> };

export const Route = createFileRoute('/app/crosswords/leaderboard')({ component: Leaderboard });

function Leaderboard() {
  const auth = useLearnerAuth();
  const board = useQuery({
    queryKey: ['crossword-leaderboard'],
    queryFn: async () => {
      const catalog = await learnerApiJson<Catalog>(auth?.getToken ?? null, `/v1/crosswords?installation_id=${getInstallationId()}`);
      if (!catalog[0]) return { entries: [] } as Board;
      return learnerApiJson<Board>(auth?.getToken ?? null, `/v1/crosswords/${catalog[0].puzzle_date}/leaderboard?installation_id=${getInstallationId()}`);
    },
  });
  return <div className="mx-auto max-w-2xl px-5 py-8"><Link to="/app/crosswords" className="font-bold text-[#2d7a13]">← Crosswords</Link><h1 className={`mt-7 ${typeScale.screenTitle}`}>Leaderboard</h1><div className="mt-7 overflow-hidden rounded-3xl border border-[#cfe8c6] bg-white">{board.data?.entries.map((entry) => <div key={`${entry.rank}-${entry.nickname}`} className={`flex items-center gap-4 border-b p-4 last:border-0 ${entry.is_you ? 'bg-[#ECFFE6]' : ''}`}><strong className="w-8 text-center">{entry.rank}</strong><span className="flex-1 font-bold">{entry.nickname}</span><span>{Math.round(entry.duration_seconds)}s</span></div>)}{board.data?.entries.length === 0 && <p className="p-6 text-slate-500">No times yet. Be the first!</p>}</div></div>;
}
